

















import { Component, Prop, Vue } from 'vue-property-decorator'
import debug from '@/helpers/debug'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import js2excel from 'js2excel'
import request from '@/helpers/requests'


interface CommRow {
    pulsemAccountId: number;
    locationName: string|null;
    smsPcheck: number|null;
    emailPcheck: number|null;
    smsBio: number|null;
    emailBio: number|null;
    smsOwm: number|null;
    emailOwm: number|null;
}


interface CommRows {
    rows: CommRow[];
}


interface CommData extends DefaultServerResponse {
    data: CommRows;
}


@Component({})
export default class CommTable extends Vue {
    @Prop() accountId!: number
    @Prop() beginDate!: string
    @Prop() fromDate!: string
    @Prop() toDate!: string
    commReport: CommRow[] = []
    search = ''
    loading = false
    commHeaders = [
        { text: 'Location Name', align: 'left', value: 'locationName' },
        { text: 'Pulsem Account Id', value: 'pulsemAccountId', align: 'left' },
        { text: 'Sms Pcheck', value: 'smsPcheck' },
        { text: 'Email Pcheck', value: 'emailPcheck' },
        { text: 'Sms Bio', value: 'smsBio' },
        { text: 'Email Bio', value: 'emailBio' },
        { text: 'Sms Owm', value: 'smsOwm' },
        { text: 'Email Owm', value: 'emailOwm' }
    ]

    /**
     * This functions retrieves the pertinent data for the report from the endpoint using accountId, fromDate, and
     * toDate.
     * @returns { CommData }
     */
    async getCommData(): Promise<CommData> {
        return await request.post('/support/franchise/comm-report', {
            accountId: this.accountId,
            beginDate: this.beginDate,
            fromDate: this.fromDate,
            toDate: this.toDate
        }) as CommData
    }

    async compileData() {
        this.loading = true
        const data = await this.getCommData()
        this.commReport = data.data.rows
        this.loading = false
    }

    /**
     * This function is responsible for the exporting of the data from the report to an excel sheet.
     * NOTE: This arranges the columns in a strange way. It sorts columns in alphabetical order.
     * These file names may also not exceed 31 characters.
     */
    exportToExcel() {
        const reportName = 'comm_report'
        const data = this.commReport
        const date = new Date().toISOString().slice(0, 10)
        const name = reportName.concat('_' + date)
        try {
            js2excel.json2excel({
                data,
                name,
                formateDate: 'yyyy/mm/dd'
            })
        } catch(e) {
            debug.error('Excel export error')
        }
    }
}
